import { ChevronDownIcon } from '@radix-ui/react-icons'
import { useMemo, useState } from 'react'
import { Button } from '@/components/orders/Button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { WithdrawUsdcModal } from '@/components/withdraw/WithdrawUsdcModal'
import { useGetLedgerBalancesSelf, useListAssets } from '@/hooks/v1'
import type { Position } from '@/hooks/v1/types/Position'
import { useDeposit } from '@/providers/DepositProvider'

export function WalletActionsButton() {
  const { available, withdrawalsAvailable, openDeposit } = useDeposit()
  const [isWithdrawOpen, setIsWithdrawOpen] = useState(false)
  const { data: assetsResponse } = useListAssets({}, { query: { enabled: withdrawalsAvailable } })
  const { data: balancesResponse } = useGetLedgerBalancesSelf({
    query: { enabled: withdrawalsAvailable },
  })
  const assets = useMemo(() => assetsResponse?.data ?? [], [assetsResponse?.data])
  const balances = useMemo<Array<Position>>(
    () => balancesResponse?.data?.balances ?? [],
    [balancesResponse],
  )

  if (!withdrawalsAvailable) return null

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="default" size="sm" type="button">
            USDC
            <ChevronDownIcon className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-40">
          {available ? (
            <DropdownMenuItem
              onSelect={() => {
                openDeposit()
              }}
            >
              Deposit
            </DropdownMenuItem>
          ) : null}
          <DropdownMenuItem
            onSelect={() => {
              setIsWithdrawOpen(true)
            }}
          >
            Withdraw
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <WithdrawUsdcModal
        isOpen={isWithdrawOpen}
        onClose={() => setIsWithdrawOpen(false)}
        assets={assets}
        balances={balances}
      />
    </>
  )
}
